import { hostName } from "./baseUrl";

// Fonctions qui permettent de déterminer la marque à afficher (marque blanche)
export const getBrandValues = () => {
	if (hostName == "v2.prevandcare.local:8890") {
		return {
			suffix: "prevandcare",
			brandName: "Prev&Care"
		};
	}
	else if (hostName == "localhost:3000" || hostName == "localhost:3001") {
		return {
			suffix: "prev&care",
			brandName: "Prev&Care"
		};
	}
	else if (hostName == "aidants.nosaimes:8890") {
		return {
			suffix: "nosaimes",
			brandName: "Nos Aimés"
		};
	}
	else {
		return {
			suffix: "prevandcare",
			brandName: "Prev&Care"
		};
	}
};